
import React from "react";
import { component_tool, framework_tool, utils_tool } from '@/tool';
import * as local_urls from '../../../../constants/constants_url';

const urls = global && global.constants && global.constants.urls ? global.constants.urls : local_urls;

let { WizModal,WizButton,WizDataTable} = component_tool;

const columns = () => {
    return [
        {
          name: "id",
          formItem: {
            type: "hidden"
          }
        },
        {
          title: "名称",
          name: "name",
          dataIndex: "name",
          searchItem: {},
          tableItem: {
            width: 100
          }
        },
        {
          title: "标识Key",
          name: "key",
          dataIndex: "key",
          searchItem: {},
          tableItem: {
            width: 120
          }
        },
        {
          title: "版本",
          name: "version",
          dataIndex: "version",
          tableItem: {
            width: 110
          }
        },
        {
          title: "部署ID",
          name: "deploymentId",
          dataIndex: "deploymentId",
          tableItem: {
            width: 150
          }
        },
        {
          title: "流程图片",
          name: "dgrmResourceName",
          dataIndex: "dgrmResourceName",
          tableItem: {
            width: 200,
            render: (text, record) => (
              <WizDataTable.Oper>
                <WizButton tooltip={text}
                           onClick={() => {
                             /*e.dispatch({
                               type:'procdef/viewResource',
                               payload: {
                                 key: 'procdef@viewResource',
                                 apiParams: {
                                   id:record['id'],
                                   deploymentId:record['deploymentId'],
                                   dgrmResourceName:record['dgrmResourceName'],
                                 }
                               },
                               callback:(response)=>{
                                 const blob = new Blob([response]);
                                 console.log(blob);
                                 const turl = window.URL.createObjectURL(blob);
                                 a.href = turl;
                                 a.download = record['dgrmResourceName'];
                                 document.body.appendChild(a);
                                 var evt = document.createEvent("MouseEvents");
                                 evt.initEvent("click", true, true);
                                 a.dispatchEvent(evt);
                                 document.body.removeChild(a);
                               }
                             })*/
                             const uploadUrl = `/api${urls.kUrlViewProcedefResource}?id=${record.id}&deploymentId=${record.deploymentId}&dgrmResourceName=${record.dgrmResourceName}&access-token=${Storage.getStorage("token")}`;
                             window.open(uploadUrl)
                             }}>
                  {text}
                </WizButton>
              </WizDataTable.Oper>
            )
          }
        },
        {
          title: "流程XML",
          name: "resourceName",
          dataIndex: "resourceName",
          tableItem: {
            width: 200,
            render: (text, record) => (
              <WizDataTable.Oper>
                <WizButton tooltip={text}
                           onClick={() => {
                             const uploadUrl = `/api${urls.kUrlViewProcedefResource}?id=${record.id}&deploymentId=${record.deploymentId}&resourceName=${record.resourceName}&access-token=${Storage.getStorage("token")}`;
                             window.open(uploadUrl)
                           }}>
                  {text}
                </WizButton>
              </WizDataTable.Oper>
            )
          }
        },
        {
          title: "状态",
          name: "suspensionState",
          dataIndex: "suspensionState",
          tableItem: {
            width: 100
          },
          dict: [
            { code: 1, codeName: "激活" },
            { code: 2, codeName: "挂起" }
          ],
          searchItem: {
            type: "select"
          },
          formItem: {
            type: "select"
          }
        },
      ];
  };
  
  const tableApi = (api = {}) => {
    return {
      path: 'procdef/listByPage',
      ...api
    }
  };
  
  const workflowProcDef = (self, api) => {
    return {
      type: 'diy',
      initialValue: [],
      rowkey: 'id',
      rowName: 'name',
      columns: columns(),
      tableApi: tableApi(api)
    }
  };
  
  export default workflowProcDef
  